module.exports = __webpack_public_path__ + "img/Yoshitaya_tc.038f33de.jpg";